import { Directive } from '@angular/core';


/**
 * Suffix to be placed at the end of the {@link TsFormFieldComponent}
 */
@Directive({ selector: '[tsSuffix]' })
export class TsSuffixDirective {}
